export default __webpack_public_path__ + "static/media/bg5.6659a94a.png";